import React, { FC, useRef } from 'react';
import OrderOnItsWay from '@assets/order_on_its_way.svg';
import TipsCover from '@assets/account-credit-desktop.png';
import styles from './CourierDetailView.module.scss';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import { IconClose } from '@justeattakeaway/pie-icons-react';
interface ICourierDetailActionsDelete {
  onDismiss: () => any;
  children?: React.ReactNode;
  isSourceDragged?: boolean;
  viewType?: 'courierDetail' | 'tips';
}

export const CourierDetailView: FC<ICourierDetailActionsDelete> = ({
  onDismiss,
  children,
  isSourceDragged = false,
  viewType = 'courierDetail',
}) => {
  const parentRef = useRef(null);
  return (
    <>
      <div className={styles.courierDetailViewContainer}>
        <div
          className={styles.courierDetailViewHeader}
          id="courierDetailViewHeader"
          onClick={onDismiss}
        >
          <IconClose size="m" />
        </div>
        {!isSourceDragged ? (
          <div className={styles.courierDetailViewImage}>
            <PIEComponentUtil paddingY="var(--xds-spacing-d)">
              <img src={viewType === 'tips' ? TipsCover : OrderOnItsWay} />
            </PIEComponentUtil>
          </div>
        ) : null}

        <div className={styles.courierDetailViewContent} ref={parentRef}>
          {children}
        </div>
      </div>
    </>
  );
};
